import * as React from 'react';
import { Grid } from 'semantic-ui-react';

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { login, logout } from '../store/modules/auth'

import LoginTipo from './LoginTipo';
import Loader from './Loader';
import LoginPaciente from './LoginPaciente';
import LoginMedico from './LoginMedico';

import config from '../helpers/config';
import loginService from '../services/login.service';
import recuperacaoService from '../services/recuperacao.service';
import SolicitarSenha from './SolicitarSenha';

class Login extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            tipo: 0,
            recuperar: false,
            subdominio: config.SUBDOMANIN
        }
    }

    loginBase = async (request, credentials, page) => {
        try {
            this.setState({ ...this.state, isLoading: true });

            const { subdominio } = this.state;
            const { success, user } = await request({ ...credentials, subdominio });

            if (success) {

                this.props.login(user);
                this.props.history.push(`/${page}`);

                return;
            } else {
                if (login.mensagem) {
                    alert(login.mensagem);
                } else {
                    alert('Dados de acesso inválidos!');
                }
            }
        } catch (error) {
            console.log(error);
            alert('Serviço indisponível, tente novamente mais tarde.');
        }

        this.setState({ ...this.state, isLoading: false });
    }

    loginPaciente = (credentials) => {
        this.loginBase(loginService.loginAsync, credentials, 'Resultados');
    }

    loginPacienteToken = (credentials) => {
        this.loginBase(loginService.loginPacienteTokenAsync, credentials, 'Resultados');
    }

    loginMedico = (credentials) => {
        this.loginBase(loginService.loginMedicoAsync, credentials, 'ResultadosFiltro');
    }

    loginConvenio = (credentials) => {
        this.loginBase(loginService.loginConvenioAsync, credentials, 'ResultadosFiltro');
    }

    loginEmpresa = (credentials) => {
        this.loginBase(loginService.loginProcedenciaAsync, credentials, 'ResultadosFiltro');
    }

    solicitarRecuperacao = async (credentials) => {
        let recuperar = true;

        try {
            this.setState({ isLoading: true });
            const { tipo, subdominio } = this.state;
            const { success } = await recuperacaoService.solicitarAsync({ tipo, subdominio, ...credentials });

            if (success) {
                alert('Em instantes você receberá um email com instruções para troca de senha.');
                recuperar = false;
            } else {
                alert('Não localizamos seu e-mail verifique o endereço informado e tente novamente.');
            }
        } catch (error) {
            console.log(error);
            alert('Serviço indisponível, tente novamente mais tarde.');
        }
        finally {
            this.setState({ isLoading: false, recuperar });
        }
    }

    recuperar = () => {
        this.setState({ recuperar: true });
    }

    componentDidMount() {
        this.props.logout();
    }

    render() {

        const { tipo, recuperar, isLoading } = this.state;

        return (
            <Grid columns={2} stackable className='gridcolumnLogin'>

                <Grid.Column>
                    <LoginTipo tipoAtendimento={tipo} onChange={(tipo) => this.setState({ tipo, recuperar: false })} />
                </Grid.Column>
                <Grid.Column className='gridcolumnLogin'>
                    <LoginPaciente className={tipo === 0 && !recuperar ? 'viewLogin' : 'viewLoginToggle'} onClick={(credentials) => this.loginPaciente(credentials)} recuperar={this.recuperar} />
                    <LoginMedico className={tipo === 1 && !recuperar ? 'viewLogin' : 'viewLoginToggle'} onClick={(credentials) => this.loginMedico(credentials)} recuperar={this.recuperar} />
                    <SolicitarSenha className={recuperar ? 'viewLogin' : 'viewLoginToggle'} onClick={(credentials) => this.solicitarRecuperacao(credentials)} />
                </Grid.Column>
                <Loader isLoading={isLoading} />
            </Grid>
        );
    }
}

const mapStateToProps = state => ({ auth: state.auth });
const mapDispatchToProps = dispatch => bindActionCreators({ login, logout }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Login);